/* eslint-disable */

// @mui material components
import { Grid, Card } from "@mui/material";

// firebase imports
import { db, auth } from "../../../../../src/Firebase";
import { getDoc, getDocs, collection, query, where, orderBy } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { getFirestore, doc, updateDoc } from "firebase/firestore";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { useMaterialUIController } from "context";
import { useEffect, useState } from "react";

// Import projects data
import Projects from "layouts/dashboard/components/Orders/components/Projects";

function Orders() {

    const [userData, setUserData] = useState({});
    const [displayNotification, setDisplayNotification] = useState(false);
    const [displayMessage, setDisplayMessage] = useState("Your order has been received!");
    const [controller, dispatch] = useMaterialUIController();
    const { userStores } = controller;
    const [user] = useAuthState(auth);

    useEffect(() => {
      (async () => {
        const userDoc = doc(db, "USERS", user.uid);
        const docSnap = await getDoc(userDoc);
        setUserData(docSnap.data());
      })();
    }, [user]);

    useEffect(() => {
      userStores.forEach(async (study) => {

        const orderDocs = collection(db, `${study}_ORDERS`);

        const q = query(
          orderDocs,
          // where("orderFor", "==", `${user.email}`),
          orderBy("date_created", "desc")
        );
        const newDoc = await getDocs(q);
        const newDocs = newDoc.docs;
        if (newDocs && newDocs.length > 0) {
          newDocs.map((el) => {
            if (el.data().status !== "cancelled" && el.data().orderFor == `${user.email}`){
              setDisplayNotification(true);
              // if (el.data().status === "shipped") {
              //   setDisplayMessage("Your order has been shipped!", user.email, el.data().orderFor);
              // }
            }
            return el.data().orderFor == `${user.email}` && ({ ...el.data(), id: el.id })
          });
        }
      });
    }, [userData, userStores]);

  return (
    <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12} sm={6} md={12}>
          {(displayNotification && !userData.hideOrderNotification) && <>
            <MDBox
              mx={2}
              mt={-3}
              mb={7}
              py={2}
              px={2}
              variant="h6"
              color="dark"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              coloredShadow="dark"
              shadow="sm"
              sx={{
                backgroundColor: '#ffea83',
                border: '1px solid #e3a136ff',
                borderRadius: '7px'
              }}
            >
              <MDTypography variant="h6" sx={{ color: '#835c00ff' }}>
                <span>{displayMessage || "Your order has been received!"}</span>
              </MDTypography>
              <MDTypography variant="h5" sx={{ color: '#bc8402ff' }}>
                <span
                  style={{
                    display: 'inline-block',
                    cursor: 'pointer',
                  }}
                  onClick={async () => {
                    const userId = auth.currentUser?.uid || null;
                    if(userId){
                      const docRef = doc(db, 'USERS', userId);
                      await updateDoc(docRef, {
                        hideOrderNotification: true,
                      });
                      setDisplayNotification(false);
                    }
                  }}
                >&times;</span>
              </MDTypography>
            </MDBox>
          </>}
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Your Orders
              </MDTypography>
            </MDBox>
            <MDBox pt={3}>
              <Projects />
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default Orders;
